export default "__VITE_ASSET__BJkVjN55__"